import React, { Component } from 'react'
import PropTypes from 'prop-types';
import Chart from 'react-apexcharts'
import HRNumbers from 'human-readable-numbers';
import {
  CircleShape,
  CountData,
  LineShape,
  ResponsiveBox,
  StateData,
  TextData
} from '../styles/main';
import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';

export class LiveAgentState extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: {
        animations: {
          enabled: false
        },
        legend: {
          show: false
        },
        offset: 1,
        dataLabels: {
          enabled: false
        },
        plotOptions: {
          pie: {
            startAngle: 0,
            endAngle: 360,
            expandOnClick: true,
            offsetX: 0,
            offsetY: 0,
            customScale: 1,
            dataLabels: {
              offset: 0,
              minAngleToShowLabel: 10
            },
            donut: {
              labels: {
                show: true
              },
            }
          }
        },
        chart: {
          animations: {
            enabled: false, //no animations
          },
        }
      }
    }
  }
  calculte(list) {
    let tD = {
      'ACW': list['ACW'] || 0,
      'preview': list['preview'] || 0,
      'offline': list['offline'] || 0,
      'online': list['online'] || 0,
      'break': list['break'] || 0,
      'logout': list['logout'] || 0,
      'transfer': (list['TRANSFER_TALK'] || 0) + (list['TRANSFER_START'] || 0) + (list['TRANSFER_CALL'] || 0),
      'ringing': (list['AGENT_CONNECTING'] || 0) + (list['AGENT_RINING'] || 0) + (list['AGENT_CONNECTED'] || 0) + (list['CUSTOMER_CONNECTING'] || 0) + (list['CUSTOMER_RINING'] || 0),
      'connected': (list['CONNECTED'] || 0),
      'Mute': (list['AGENT_MUTE'] || 0),
      'HOLD': (list['AGENT_HOLD'] || 0),
    }
    return tD;
  }

  splitInto2(list) {
    let tD = {
      "1": {
        'Online': list['Online'] || 0,
        'Offline': list['Offline'] || 0,
      },
      "2": {
        'Ringing': list['Ringing'] || 0,
        'Connected': list['Connected'] || 0,
      },
      "3": {
        'Mute': list['Mute'] || 0,
        'Hold': list['Hold'] || 0,
      },
      "4": {
        'Transfer': list['Transfer'] || 0,
        'ACW': list['ACW'] || 0,
      },
      "5": {
        'Preview': list['Preview'] || 0,
        'Break': list['Break'] || 0,
      },
      "6": {
        'Logout': list['Logout'] || 0,
      }
    }
    return tD;
  }

  getCount(list) {
    let result = {
      series: [],
      labels: [],
    }
    for (const key in list) {
      if (Object.hasOwnProperty.call(list, key)) {
        result.series.push(list[key])
        result.labels.push(key)
      }
    }
    return result;
  }

  renderCol(oList) {
    return (
      <React.Fragment>
        {
          Object.keys(oList).length && Object.keys(oList).map(function (key) {
            return (
              <ResponsiveBox sm={6} style={{ padding: '0px 8px' }}>
                <StateData>
                  {/* <LineShape></LineShape> */}
                  <TextData>{key}</TextData>
                  <CountData>{HRNumbers.toHumanString(oList[key] || 0)}</CountData>
                </StateData>
              </ResponsiveBox>
            )
          })
        }
      </React.Fragment>)
  }

  render() {
    var _this = this;
    const { list } = this.props;
    let result = this.getCount(list);
    let cList = this.splitInto2(list);
    this.state.options["series"] = result.series;
    this.state.options["labels"] = result.labels;

    return (
      <Row className='w-100'>
        {Object.keys(cList).length && Object.keys(cList).map(function (key) {
          return (
            <React.Fragment>
              {cList[key] && _this.renderCol(cList[key])}
            </React.Fragment>
          )
        })
        }
      </Row>
    )
  }
}
LiveAgentState.contextTypes = {
  __: PropTypes.func
};

export default LiveAgentState;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/LiveAgentState.js